import { createLogger } from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';

import { appReducer } from './app/appSlice';
import { goalsReducer } from './goals/goalSlice';
import { partnerReducer } from './partner/partnerSlice';
import { queueReducer } from './queue/queueSlice';
import { reviewReducer } from './review/reviewSlice';
import { rubricReducer } from './rubric/rubricSlice';
import { ticketReducer } from './ticket/ticketSlice';
import { userReducer } from './user/userSlice';

const isDev = process.env.NODE_ENV === 'development';

const logger = createLogger();
const store = configureStore({
    reducer: {
        app: appReducer,
        goals: goalsReducer,
        partner: partnerReducer,
        queue: queueReducer,
        review: reviewReducer,
        rubric: rubricReducer,
        ticket: ticketReducer,
        user: userReducer,
    },
    devTools: isDev,
    middleware: (getDefaultMiddleware) => (isDev ? getDefaultMiddleware().concat(logger) : getDefaultMiddleware()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
